export default "__VITE_ASSET__6e7jmTty__"